import React from 'react';
import PropTypes from 'prop-types';

import ManagementLayout from 'components/layouts/ManagementLayout';

import UsersContent from './components/UsersContent';

/**
 * User Management landing page (PD-4063): the paginated, sortable users table.
 *
 * The mockup's TEAMS column waits on PD-4213.
 *
 * This component holds no state on purpose — see UsersContent for why the shell
 * and the page body are split.
 */
function Users({ appLinks, canEdit, currentPath, currentUser, footer }) {
  return (
    <ManagementLayout
      appLinks={appLinks}
      currentPath={currentPath}
      currentUser={currentUser}
      footer={footer}
    >
      <UsersContent canEdit={canEdit} />
    </ManagementLayout>
  );
}

Users.propTypes = {
  appLinks: ManagementLayout.propTypes.appLinks,
  /** Whether the viewer may remove or restore access, not only browse. */
  canEdit: PropTypes.bool,
  currentPath: PropTypes.string,
  currentUser: ManagementLayout.propTypes.currentUser,
  footer: ManagementLayout.propTypes.footer,
};

Users.defaultProps = {
  appLinks: [],
  canEdit: false,
  currentPath: undefined,
  currentUser: undefined,
  footer: undefined,
};

export default Users;
